import uuid from 'uuid-random';
import { none, propEq, values } from 'ramda';
import { ACTION, AdvancedPlayerMessage, BUTTON_TYPE } from 'js/components/popups/AdvancedPlayerMessage';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const actionShowAdvancedDialogInfo = ({ actionId, actionInfo, windowSessionId, push }) => {
    const { buttons = [], targetSubscription } = actionInfo;

    if (targetSubscription === 'advanced-dialog') {
        publicEventsAPIService.trigger('advanced-dialog', {
            actionId,
            actionInfo,
            windowSessionId
        });
        return;
    }

    if (targetSubscription === 'advanced-dialog-nongame') {
        publicEventsAPIService.trigger('advanced-dialog-nongame', {
            actionId,
            actionInfo,
            windowSessionId
        });
        return;
    }

    const unsupportedButton = buttons
        .filter(btn => btn.action)
        .find(btn => !values(ACTION).includes(btn.action));

    if (unsupportedButton) {
        console.warn('Unsupported button action', unsupportedButton);
        return;
    }

    const isModal = none(propEq('buttonType', BUTTON_TYPE.CLOSE), buttons);
    const buttonsWithIds = buttons.map(({ buttonId = uuid(), ...rest }) => ({ ...rest, buttonId }));

    return addPopupAction({
        id: actionId,
        component: AdvancedPlayerMessage,
        layer: isModal ? LAYER.ADVANCED_PLAYER_MESSAGE_MODAL : LAYER.ADVANCED_PLAYER_MESSAGE,
        isModal,
        data: {
            ...push.data,
            action: {
                ...actionInfo,
                buttons: buttonsWithIds
            }
        }
    });
};
